import actionTypes from "./_actions";
import authActionTypes from "containers/Auth/_actions";

const INITIAL_STATE = {
    isLoading: false,
    tickets: [],
    showModal: false,
};

function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case actionTypes.SUBMIT_SUPPORT_REQUEST_SUCCESS: {
            const fauxTicket = {
                tempId: state.tickets.length + 1,
                subject: action.payload.subject,
                description: action.payload.request,
                status: "Submitted",
                comments: [],
            };
            return {
                ...state,
                tickets: [fauxTicket].concat(state.tickets),
            };
        }
        case actionTypes.GET_TICKETS:
            return {
                ...state,
                isLoading: true,
            };
        case actionTypes.GET_TICKETS_SUCCESS: {
            const payloadHasNewTickets = action.payload.reduce((result, payloadTicket) => {
                if (!state.tickets.some((stateTicket) => stateTicket.id === payloadTicket.id)) result = true;
                return result;
            }, false);
            const updateStateTickets = payloadHasNewTickets || action.payload.length === state.tickets.length;
            return {
                ...state,
                isLoading: false,
                tickets: updateStateTickets ? action.payload : state.tickets,
            };
        }
        case actionTypes.OPEN_SUPPORT_MODAL:
            return {
                ...state,
                modal: action.payload,
            };
        case actionTypes.CLOSE_SUPPORT_MODAL:
            return {
                ...state,
                modal: undefined,
            };
        case authActionTypes.AUTH_CLEAR_STORAGE:
            return INITIAL_STATE;
        default:
            return state;
    }
}

export default reducer;
